import { render } from "./MfittBookingError.vue?vue&type=template&id=75f953a1"
import script from "./MfittBookingError.vue?vue&type=script&lang=js"
export * from "./MfittBookingError.vue?vue&type=script&lang=js"
script.render = render

export default script